import {
  convertLanguageToBCP47Language,
  convertLanguageToNativeLanguage,
  Language,
  translateLanguageName,
} from '@faceup/utils'
import { useLocalization } from '../contexts'

export type LanguageNameType = 'native' | 'translated'

type LanguageObject = {
  language: Language
  nativeName: string
  translatedName: string
}

export const useLanguageName = () => {
  const localization = useLocalization()
  const getLanguageName = ({
    type,
    language,
  }: {
    type: LanguageNameType
    language: Language
  }): string => {
    const getName = () => {
      if (type === 'native') {
        return convertLanguageToNativeLanguage(language)
      }
      return (
        translateLanguageName(language, convertLanguageToBCP47Language(localization.language)) ?? ''
      )
    }

    const languageName = getName()
    return languageName.charAt(0).toUpperCase() + languageName.slice(1)
  }

  const getLanguageList = (params?: {
    specificLanguages?: Language[]
    sortBy?: LanguageNameType
  }): LanguageObject[] => {
    const { specificLanguages, sortBy = 'translated' } = params ?? {}
    const filteredLanguages = Object.values(Language).filter(language =>
      specificLanguages === undefined ? true : specificLanguages.includes(language)
    )
    const sortedLanguages = filteredLanguages.sort((a, b) =>
      getLanguageName({ type: sortBy, language: a }).localeCompare(
        getLanguageName({ type: sortBy, language: b })
      )
    )
    return sortedLanguages.map(language => ({
      language,
      nativeName: getLanguageName({ type: 'native', language }),
      translatedName: getLanguageName({ type: 'translated', language }),
    }))
  }

  return {
    getLanguageName,
    getLanguageList,
  }
}
